import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { customAxios } from "lib/axios";

export interface ProgramWithMembers {
  _id: string;
  name: string;
  description?: string;
  status?: "active" | "inactive" | string;
  parentDepartmentId?: string;
  members?: Array<{
    memberId: string;
    assignedBy?: string;
    assignedAt?: string;
  }>;
  createdAt?: string;
  updatedAt?: string;
  __v?: number;
}

export type UserProgramsResponse = {
  success: boolean;
  message: string;
  data: ProgramWithMembers[];
};

const fetchUserPrograms = async (userId: string): Promise<UserProgramsResponse> =>
  (await customAxios.get<UserProgramsResponse>(`/programs/user/${userId}`)).data;

export const useGetUserPrograms = (userId: string | null) =>
  useQuery<UserProgramsResponse, AxiosError>(
    ["programs", "user", userId],
    () => fetchUserPrograms(userId!),
    {
      enabled: !!userId,
      staleTime: 0,
      retry: 1,
      refetchOnMount: "always",
    }
  );
